import { FlexContainer } from "./FlexContainer";

export class CFlexContainer extends FlexContainer {
    protected initialize(data: any) {
        super.initialize(data);
        this.addClass("cfc");
    }
}
